import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { NotificationService } from "../../services/notificationalert.services";
import { logger } from "../../utils/logger";

const log = logger.getLogger("FileErrors");

interface AddRequest {
  name: string;
  message: string;
  audience: string;
  type: string;
  maintenanceStartWindow: string | null;
  maintenanceEndWindow: string | null;
  active: boolean;
  triggeredBy: string;
}

interface NotificationItem {
  name: string;
  triggeredBy: string;
  audience: string;
  maintenanceStartWindow: string;
  maintenanceEndWindow: string;
  notificationId: string;
  message: string;
  type: string;
  status: string;
  // add other fields as needed
}

export const addRequest = createAsyncThunk("add/notification", async ({ request }: { request: AddRequest }, { rejectWithValue }) => {
  try {
    const response = await NotificationService.addsingleTemplate(request);

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error: any) {
    log.warn(JSON.stringify(error));
    return rejectWithValue({
      message: error?.response?.data || error.message,
      status: error?.response?.status,
    });
  }
});

export const getNotificationStatus = createAsyncThunk("check/notificationStatus", async ({ audience }: { audience: string }, { rejectWithValue }) => {
  try {
    const res = await NotificationService.getNotificationStatus(audience);
    return { data: res };
  } catch (e) {
    log.warn(JSON.stringify(e));
    return rejectWithValue(null);
  }
});

export const getStripeStatus = createAsyncThunk("check/stripeStatus", async (_, { rejectWithValue }) => {
  try {
    const res = await NotificationService.getStripeStatus();
    return { data: res };
  } catch (e) {
    log.warn(JSON.stringify(e));
    return rejectWithValue(null);
  }
});

export const getStripeActiveStatus = createAsyncThunk("check/stripeActiveStatus", async (_, { rejectWithValue }) => {
  try {
    const res = await NotificationService.getStripeActiveStatus();
    return { data: res };
  } catch (e) {
    log.warn(JSON.stringify(e));
    return rejectWithValue(null);
  }
});

export const getNotificationData = createAsyncThunk("get/notificationData", async (_, { rejectWithValue }) => {
  try {
    const res = await NotificationService.getNotificationData();
    return { data: res };
  } catch (e) {
    log.warn(JSON.stringify(e));
    return rejectWithValue(null);
  }
});
export const updateNotificationData = createAsyncThunk("update/Notification", async (updatedRow: NotificationItem, { rejectWithValue }) => {
  try {
    const response = await NotificationService.updateNotificationData(updatedRow);
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    log.warn(JSON.stringify(error));
    return rejectWithValue(error);
  }
});
